import React from 'react'
import FLOWS from 'checkIn/flows'
import { useCheckIn } from 'checkIn/CheckInContext'
import type { RouteComponent } from 'types'
import Teen from './Teen'
import Kid from './Kid'
import { useCroods } from 'croods'

const SCREEN_NAME = 'impactQ6'

const ImpactQ6: RouteComponent = ({ studentId }) => {
  const { student } = useCheckIn()
  const [{ saving }, { save }] = useCroods({
    name: 'impactMeasurement',
    path: `students/${studentId}/impact_measurements`,
  })

  if (!student) return null

  if (student.studentType === 'teen')
    return <Teen nextFunction={FLOWS.teen[SCREEN_NAME].nextFunction} save={save} saving={saving} />

  if (student.studentType === 'kid')
    return <Kid nextFunction={FLOWS.kid[SCREEN_NAME].nextFunction} save={save} saving={saving} />

  return null
}

export default ImpactQ6
